import PropTypes from 'prop-types'
import styled from 'styled-components'

import List from 'pages/DeviceSearch/MultipleDevicesResults/List'
import SingleDeviceResult from 'pages/DeviceSearch/SingleDeviceResult'

import { color } from 'styles/colors'
import { useLocation } from 'react-router-dom'

const propTypes = {
  pathRoot: PropTypes.string.isRequired,
  devices: PropTypes.arrayOf(PropTypes.shape),
  invalidDeviceIds: PropTypes.arrayOf(PropTypes.string)
}

const defaultProps = {
  devices: null,
  invalidDeviceIds: null
}

const MultipleDevicesResults = ({ pathRoot, devices, invalidDeviceIds }) => {
  if ((devices && devices.length === 1) && _.isEmpty(invalidDeviceIds)) {
    return <SingleDeviceResult device={devices[0]} />
  }

  return (
    <>
      {invalidDeviceIds?.length > 0 && (
        <>
          <S.InvalidIds>Devices not found: <span>{invalidDeviceIds.sort().join(', ')}</span></S.InvalidIds>
          <S.InvalidIdsTips>Please ensure the thermostat has been registered in Home and is connected to WIFI.</S.InvalidIdsTips>
        </>
      )}

      {devices && devices.length > 0 && (
        <List {...{ devices, pathRoot }} />
      )}
    </>
  )
}

MultipleDevicesResults.propTypes = propTypes
MultipleDevicesResults.defaultProps = defaultProps

export default MultipleDevicesResults

const S = {
  ResultsTitle: styled.h2`
    margin-top: 40px;
    margin-bottom: 10px;
  `,
  InvalidIds: styled.div`
    margin-top: 30px;
    font-weight: bold;

    > span {
      color: ${color('errorText')};
    }
  `,
  InvalidIdsTips: styled.div`
    margin-bottom: 30px;
  `
}
